
import { defineComponent } from 'vue'

interface SlotAnimation {
  text: string
  duration: number
  delay: number
  slidesUp: boolean
}

const labelOptions = [
  ['Mo', '모', '문', 'モ', '門', '扉'],
  ['To', '토', 'と', 'ト'],
  ['Bi', '비', 'び', 'ビ'],
]

const pairAnimationGroups = [
  [0, 1],
  [0, 2],
  [1, 2],
]

export default defineComponent({
  data(): { slots: SlotAnimation[]; timeouts: number[] } {
    return {
      slots: labelOptions.map((labels) => ({
        text: labels[0],
        duration: 360,
        delay: 0,
        slidesUp: true,
      })),
      timeouts: [],
    }
  },
  mounted() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }

    this.scheduleInitialBurst()
  },
  beforeUnmount() {
    this.clearScheduledAnimations()
  },
  methods: {
    scheduleInitialBurst() {
      this.animateNextGroup(260, 340)
      this.timeouts.push(
        window.setTimeout(() => {
          this.animateNextGroup(260, 340)
          this.timeouts.push(
            window.setTimeout(() => {
              this.scheduleLoop()
            }, 460)
          )
        }, 460)
      )
    },
    scheduleLoop() {
      const delay = this.randomInt(1600, 3200)
      this.timeouts.push(
        window.setTimeout(() => {
          this.animateNextGroup(360, 460)
          this.scheduleLoop()
        }, delay)
      )
    },
    clearScheduledAnimations() {
      this.timeouts.forEach((timeout) => window.clearTimeout(timeout))
      this.timeouts = []
    },
    animateNextGroup(minDuration: number, maxDuration: number) {
      const group = this.randomAnimationGroup()
      this.slots = this.slots.map((slot, index) => {
        if (!group.includes(index)) {
          return slot
        }

        return {
          text: this.nextLabel(labelOptions[index], slot.text),
          duration: this.randomInt(minDuration, maxDuration),
          delay: group.indexOf(index) * 45,
          slidesUp: Math.random() < 0.5,
        }
      })
    },
    randomAnimationGroup(): number[] {
      if (this.randomInt(0, 99) < 30) {
        return pairAnimationGroups[
          this.randomInt(0, pairAnimationGroups.length - 1)
        ]
      }

      return [0, 1, 2]
    },
    nextLabel(labels: string[], currentText: string): string {
      let nextText = currentText
      while (nextText === currentText) {
        nextText = labels[this.randomInt(0, labels.length - 1)]
      }
      return nextText
    },
    randomInt(min: number, max: number): number {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    slotWidth(index: number): string {
      return index === 0 ? '1.14em' : '1em'
    },
  },
})
